
import Button from '@/ui-kit/components/button';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import routes from '@/constants/routes';

export default {
  name: 'NewListingComponent',
  components: {
    Button,
  },
  data() {
    return {
      fields: {
        listing_card_title: null,
        listing_card_text: null,
        listing_card_button: null,
      },
      StyleColorSchemeType,
    };
  },
  async fetch() {
    await this.getContent();
  },
  methods: {
    async getContent() {
      const { data } = await this.$prismic.client.getSingle('my_listings');
      this.fields.listing_card_title = data.listing_card_title;
      this.fields.listing_card_text = data.listing_card_text;
      this.fields.listing_card_button = data.listing_card_button;
    },

    handleSellButtonClick() {
      this.$track(ListingPageEvent.SellYourHome);
      this.$router.push(routes.listHome);
    },
  },
};
